import {
    Button, FormControl,
    FormLabel,
    Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay
} from "@chakra-ui/react";
import { useSession } from "next-auth/react";
import { useRouter } from "next/dist/client/router";
import React from "react";
import toast from "react-hot-toast";
import { variant } from "theme/names";
import { postData } from '../../utils/helpers';
import { getAccount } from "../../utils/sessionHelper";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { ModalInfoIcon } from "./ModalInfoIcon";

export const ImportTweet = ({ isOpen, onClose, refresher, selectedListId }) => {

    const initialRef = React.useRef<HTMLInputElement>(null);
    const isAuthenticated = useFirebaseUser();
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"


    const router = useRouter();
    const [isImporting, setIsImporting] = React.useState(false);
    const [toImportTweets, setToImportTweets] = React.useState("");

    const cancelRef = React.useRef() as React.MutableRefObject<HTMLButtonElement>;

    const handleChange = (event) => setToImportTweets(event.target.value);

    const importTweets = async () => {
        // console.log(toImportTweets);
        let tweets = toImportTweets.split(',');

        if (tweets.length > 10) {
            toast.error("We don't support more than 10 posts");
            onClose();
        }

        if (isAuthenticated) {
            setIsImporting(true);
            let res = await postData({ 
                url: "https://us-central1-ez4cast.cloudfunctions.net/leader-importPosts", 
                isAbsolute: true, token: "", 
                data: { idUser: getAccount(session)?.id, idLinkedin: getAccount(session)?.idLinkedin, urls: tweets, idList: selectedListId } 
            });

            setIsImporting(false);
            onClose();

            if (res.success) {
                toast.success("posts imported successfully", { style: { background: "gray.600", color: "#222" } });
                refresher({});
            }
            else if (res.error) {
                toast.error(res.error);
                refresher({});
            }
            else {
                toast.error("An error occurred during the import. Some posts has not been imported.", { style: { background: "gray.600", color: "#222" } });
            }
        }
    }

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {/* <ModalInfoIcon /> */}
            Import Posts
          </ModalHeader>
          <ModalCloseButton _hover={{ bg: "blue.100" }} />
          <ModalBody pb={6}>
            <FormControl
              as="form"
              onSubmit={(e) => {
                e.preventDefault();
                importTweets();
              }}
            >
              <FormLabel>Enter post urls (comma separated)</FormLabel>
              <Input
                placeholder="https://www.linkedin.com/posts/alexanderberman_stripe-checkout-activity-6899351460870459392--_QM"
                onChange={handleChange}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={onClose}
            //   mr={3}
            //   bg="blue.50"
            //   _hover={{ bg: "blue.100" }}
              variant="tertiary"
            >
              Cancel
            </Button>
            <Button
              onClick={importTweets}
              //   colorScheme="blue"
              //   bg="blue.700"
              variant={variant.Button.primary}
              isLoading={isImporting}
            >
              Add
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
}
